import { IsArray, IsDefined, IsInt, IsISO8601, IsNotEmpty, IsOptional, Matches, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';
export class StandAloneOrderProductExcludePriceDto {
  @IsOptional()
  @IsInt()
  orderId: number;

  @IsDefined()
  @IsISO8601()
  @Matches(/^\d{4}-\d{2}-\d{2}$/)
  date: string;

  @IsDefined()
  @IsInt()
  posDeviceId: number;

  @IsDefined()
  @IsInt()
  merchantId: number;

  @IsDefined()
  @IsInt()
  applicationSourceId: number;

  @IsDefined()
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({each: true})
  @Type(() => OrderItemExcludePrice)
  insertOrderItems: OrderItemExcludePrice[];
}

export class OrderItemExcludePrice {
  @IsDefined()
  @IsInt()
  menuId: number;

  @IsDefined()
  @IsInt()
  productId: number;

  @IsDefined()
  @IsInt()
  quantity: number;

  @IsOptional()
  @IsArray()
  @IsNotEmpty()
  @ValidateNested({each: true})
  @Type(() => OrderItemModifierExcludePrice)
  orderItemModifiers?: OrderItemModifierExcludePrice[];
}

export class OrderItemModifierExcludePrice {
  @IsDefined()
  @IsInt()
  modifierId: number;

  @IsDefined()
  @IsInt()
  modifierGroupId: number;
}
